import React from "react";

import { useField } from "formik";
import { useTranslation } from "react-i18next";

import { Label, FormField } from "semantic-ui-react";

const MyTextArea = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  const { t, i18n } = useTranslation();

  return (
    <FormField error={meta.touched && !!meta.error}>
      <label for={props.name} id={props.name}>
        {label}
      </label>
      <textarea {...field} {...props} />
      {meta.touched && meta.error ? (
        <Label style={{ marginTop: ".5rem", border: "0px" }} basic color="red">
          {meta.error}
        </Label>
      ) : null}
    </FormField>
  );
};

export default MyTextArea;
